import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconPadlockLockedSvg } from './IconPadlockLockedSvg';

export const IconPadlockLocked: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconPadlockLockedSvg} {...iconProps} />;
};
